/* global google */
/* global jQuery */
/* global require */
'use strict'; //eslint-disable-line

angular
  .module('employeesByArea')
  .component('employeesByArea', {
    template: require('./employees-by-area.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi',
      function EmployeesByAreaController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, uiGmapGoogleMapApi) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'washes';
        $rootScope.menu = 'employeesByArea';
        $scope.map = { control: {}, center: { latitude: 37.53617251919567, longitude: 126.89153730869292 }, zoom: 10 };
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.metaInfo = { title: '', areaNames: [] };
        this.multiTableEnabled = false;
        this.initInfo = () => {
          this.targetArea = undefined;
          this.metaInfo.title = '지역구 설정된 테크니션 정보';
          this.metaInfo.areaNames = [];
          this.multiTableEnabled = false;
          $resource(`${APIURL}/admin/employees/areas/all`).get({}).$promise
            .then((data) => {
              this.metaInfo.allEmployees = data.employees;
              data.employees.forEach((employee) => {
                const areaDic = { areaName: `${employee.CITY_NAME} ${employee.AREA_NAME}`, employeeCount: 1, tbAreaId: employee.TB_AREA_ID, tbAreaIdForAdmin: employee.TB_AREA_ID_FOR_ADMIN };
                let existAreaDic = false;
                this.metaInfo.areaNames.forEach((_areaDic) => {
                  if (_areaDic.areaName === areaDic.areaName) {
                    existAreaDic = true;
                    _areaDic.employeeCount += 1;
                  }
                });
                if (!existAreaDic) {
                  this.metaInfo.areaNames.push(areaDic);
                }
              });
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.selectArea = (tbAreaId, tbAreaIdForAdmin) => {
          this.multiTableEnabled = false;
          this.targetArea = this.areas.filter(area => area.ID === tbAreaId)[0];
          const areaId = tbAreaIdForAdmin || tbAreaId;
          $resource(`${APIURL}/admin/employees/areas/${areaId}`).get({}).$promise
            .then((employees) => {
              this.employees = employees.employees;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.selectAreaOnTheMap = (tbAreaId) => {
          this.targetArea = this.areas.filter(area => area.ID === tbAreaId)[0];
          $resource(`${APIURL}/admin/employees/areas/${tbAreaId}`).get({}).$promise
            .then((employees) => {
              this.employees = employees.employees;
              this.multiTableEmployees = {};
              this.multiTableTitles = [];
              employees.employees.forEach((employee) => {
                const areaName = employee.AREA_NAME;
                if (!this.multiTableEmployees[areaName]) {
                  this.multiTableEmployees[areaName] = [];
                  this.multiTableTitles.push(areaName);
                }
                this.multiTableEmployees[areaName].push(employee);
              });
              this.multiTableEnabled = this.multiTableTitles.length > 1;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        uiGmapGoogleMapApi.then(() => {
          $resource(`${APIURL}/maps/areas`).get({}).$promise
            .then((data) => {
              this.areas = data.areas;
              data.areas.forEach((area) => {
                const path = area.POLYLINE.replace('\n', '\\n');
                const color = '#5694cc';
                const polyline = new google.maps.Polygon({
                  path: google.maps.geometry.encoding.decodePath(path),
                  geodesic: true,
                });
                const polylineReset = (_polyline) => {
                  const defaultOptions = {
                    strokeColor: color,
                    fillColor: color,
                    strokeOpacity: 1.0,
                    fillOpacity: 0.3,
                    strokeWeight: 2,
                  };
                  _polyline.setOptions(defaultOptions);
                };
                const polylineHilighted = (_polyline) => {
                  const overOptions = {
                    strokeColor: color,
                    fillColor: color,
                    strokeOpacity: 1.0,
                    fillOpacity: 0.3,
                    strokeWeight: 4,
                  };
                  _polyline.setOptions(overOptions);
                };
                polylineReset(polyline);
                polyline.setMap($scope.map.control.getGMap());
                polyline.addListener('mouseover', () => {
                  polylineHilighted(polyline);
                });
                polyline.addListener('mouseout', () => {
                  polylineReset(polyline);
                });
                polyline.addListener('click', () => {
                  this.targetArea = area;
                  this.selectAreaOnTheMap(area.ID);
                });
              });
              this.initInfo();
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/employees-by-area/employees-by-area.component.js